<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'header.enterprise_service_types' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion>
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onPageChange(0, paginate.pageSize)">
          <div class="row">
            <!-- Tên nhom-->
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <input type="text"
                  (focusout)="documents.name = documents.name == undefined ? '' : (documents.name + '').trim()"
                  #focusInput matInput [placeholder]="'search_form.service_type_name' | translate" name="name"
                  [(ngModel)]="documents.name" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="documents.name=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Ghi chú -->
            <!-- <div class="col-lg-6">
              <mat-form-field class="w-100">
                <input (focusout)="documents.note = documents.note == undefined ? '' : (documents.note + '').trim()"
                       matInput [placeholder]="'search_form.note' | translate" name="note"
                       [(ngModel)]="documents.note" maxlength="200" autocomplete="off">
              </mat-form-field>
            </div> -->
            <div class="col-lg-4 d-flex align-items-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()"
                [disabled]="!myForm.valid || isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_contract.buttons.search' | translate}}
              </button>
            </div>
          </div>
          <br>
          <!-- <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()"
                      [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_contract.buttons.search' | translate}}
              </button>
            </div>
          </div> -->
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <span>{{'service_type.service_type_list' | translate}} ({{paginate.totalRow}})</span>
          <div class="d-flex list-div">
            <button class="pull-right mr-1" mat-stroked-button color="primary" type="button"
              *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM) && isBuyTwoService && isDefaultAdmin"
            (click)="openDialogSync()" >
              <mat-icon class="mr-0">refresh</mat-icon>
              {{'button.synchronized' | translate}}
              {{'notify.from' | translate}}
              <span *ngIf="!isNotAttestedUser">sContract</span>
              <span *ngIf="isNotAttestedUser">vContract</span>
            </button>
            <button class="pull-right mr-1" mat-stroked-button color="primary"
              type="button" *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM)"
              routerLink="/home-enterprise/add-document-group-v2" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon>
              {{'button.add' | translate}}
            </button>
            <button class="pull-right list-btn4" mat-stroked-button color="primary" type="button"
              routerLink="/home-enterprise/config-general-manage" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">settings</mat-icon>
              {{'button.config' | translate}}
            </button>
          </div>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" width="100%">
            <!-- STT -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef
                class="special mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                <div>{{'enterprise_contract.table_headers.No' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
                {{paginate.no[dataSource.filteredData.indexOf(element)]}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- group name -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef
                class=" special mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div>{{'headertable.service_type_name' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.name }}"
                class="d-flex align-items-center mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                <i *ngIf="element.type == 2" style="font-size: 10px;" class="fa fa-star text-primary mr-1"></i>
                {{element.name}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Code -->
            <ng-container matColumnDef="code">
              <mat-header-cell *matHeaderCellDef class="special mat-header-cell-center mat-cell-non-boder-right-bottom">
                <div>{{'search_form.service_type_code' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.code }}"
                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                {{element.code}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Ghi chú Column -->
            <ng-container matColumnDef="note">
              <mat-header-cell *matHeaderCellDef class="special mat-header-cell-center">
                <div>{{'headertable.note' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.note }}" (click)="$event.stopPropagation()">
                {{element.note}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- allow EKYC -->
            <!-- <ng-container matColumnDef="allowEKYC">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_allowEKYC' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        matTooltip="{{ !isReadySignEkyc ? ('enterprise_document_template_add_pop.notReadySignEkycAndEkycAdvanced' | translate) :
                            ( element.allowEkyc ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                            ('enterprise_document_template_add_pop.allowCheckFalse' | translate)) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button [disabled]="(!isReadySignEkyc)" mat-icon-button
                        (click)="(isReadySignEkyc) ? onAllowCheckSign(element, element.allowEkyc, 'allowEkyc') : ''">
                  <mat-icon *ngIf="element.allowEkyc" color="primary">check_box</mat-icon>
                  <mat-icon *ngIf="element.allowEkyc === false" color="primary">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- allow EKYC advanced-->
            <!-- <ng-container matColumnDef="allowEkycAdvanced">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_allowEkycAdvanced' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        matTooltip="{{ !isReadySignEkycAdvanced ? ('enterprise_document_template_add_pop.notReadySignEkycAndEkycAdvanced' | translate) :
                            ( element.allowAdvancedEkyc ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                            ('enterprise_document_template_add_pop.allowCheckFalse' | translate)) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button [disabled]="(!isReadySignEkycAdvanced)" mat-icon-button
                        (click)="(isReadySignEkycAdvanced) ? onAllowCheckSign(element, element.allowAdvancedEkyc, 'allowAdvancedEkyc') : ''">
                  <mat-icon *ngIf="element.allowAdvancedEkyc" color="primary">check_box</mat-icon>
                  <mat-icon *ngIf="element.allowAdvancedEkyc === false" color="primary">check_box_outline_blank</mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- allowOtp -->
            <!-- <ng-container matColumnDef="allowOtp">
              <mat-header-cell *matHeaderCellDef class="sub-header-center sub-header-col">
                {{'search_form.service_type_allowOtp' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allowOtp ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()"
                        style="min-width: 91px; width: 91px; max-width: 91px;">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, element.allowOtp, 'allowOtp')">
                  <mat-icon color="primary" *ngIf="element.allowOtp">check_box</mat-icon>
                  <mat-icon color="primary" *ngIf="element.allowOtp === false">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- allowImage -->
            <!-- <ng-container matColumnDef="allowImage">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_allowImage' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allowImage ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, element.allowImage, 'allowImage')">
                  <mat-icon color="primary" *ngIf="element.allowImage">check_box</mat-icon>
                  <mat-icon color="primary" *ngIf="element.allowImage === false">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- checkCertNumber -->
            <!-- <ng-container matColumnDef="checkCertNumber">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_checkCertNumber' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.checkCertNumber ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, element.checkCertNumber, 'checkCertNumber')">
                  <mat-icon color="primary" *ngIf="element.checkCertNumber">check_box</mat-icon>
                  <mat-icon color="primary" *ngIf="element.checkCertNumber === false">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- checkName -->
            <!-- <ng-container matColumnDef="checkName">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_checkName' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.checkName ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, element.checkName, 'checkName')">
                  <mat-icon color="primary" *ngIf="element.checkName">check_box</mat-icon>
                  <mat-icon color="primary" *ngIf="element.checkName === false">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- checkOtp -->
            <!-- <ng-container matColumnDef="checkOtp">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_checkOtp' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.checkOtp ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                ('enterprise_document_template_add_pop.allowCheckFalse' | translate) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, element.checkOtp, 'checkOtp')">
                  <mat-icon color="primary" *ngIf="element.checkOtp">check_box</mat-icon>
                  <mat-icon color="primary" *ngIf="element.checkOtp === false">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- Bổ trợ EKYC -->
            <!--  -->
            <!-- <ng-container matColumnDef="supportEkyc">
              <mat-header-cell *matHeaderCellDef class="sub-header-right sub-header-col">
                {{'search_form.service_type_supportEKYC' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        matTooltip="{{ (!isReadySignEkyc && !isReadySignEkycAdvanced) ? ('enterprise_document_template_add_pop.notReadySignEkycAndEkycAdvanced | translate') :
                               (((!element.allowOtp && !element.allowImage)) ? ('enterprise_document_template_add_pop.no_config_ekyc' | translate) :
                                (element.ekycSupportConfig == 1 || element.ekycSupportConfig == 2) ? ('enterprise_document_template_add_pop.allowCheckTrue' | translate) :
                               ('enterprise_document_template_add_pop.allowCheckFalse' | translate)) }}"
                        class="mat-header-cell-center mat-cell-non-boder-right-bottom sub-header-col" (click)="$event.stopPropagation()">
                <button mat-icon-button
                        (click)="onAllowCheckSign(element, !!element.ekycSupportConfig, 'checkEkycSupport')"
                        [disabled]="isDisableEKYC || (!element.allowOtp && !element.allowImage)"
                >
                  <mat-icon *ngIf="element.ekycSupportConfig" color="primary">check_box</mat-icon>
                  <mat-icon *ngIf="!element.ekycSupportConfig" color="primary">check_box_outline_blank
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container> -->

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol ">
              <mat-header-cell *matHeaderCellDef class="special mat-header-cell-centermat-cell-non-boder-bottom"
                style="max-width: 140px;">
                <div>{{'headertable.action' | translate}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-header-cell-centermat-cell-non-boder-bottom d-flex justify-content-center"
                style="max-width: 140px;" (click)="$event.stopPropagation()">
                <!-- <button (click)="onOpenConfigDocumentGroupDialog(element)" mat-icon-button style="position: relative; top: 3px" [disabled]="commonService.getIsLockedEnterprise()">
                  <span matTooltip="{{'enterprise_customer_management.buttons.configure' | translate}}">
                    <mat-icon class="custon-icon-setting-configure">settings</mat-icon>
                  </span>
                </button>
                <button mat-icon-button (click)="onOpenAddOrEditDialog(element)" [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_customer_management.buttons.edit' | translate}}">edit
                  </mat-icon>
                </button> -->
                <!--                <button (click)="onOpenConfigDocumentGroupDialog(element)" mat-icon-button style="position: relative; top: 3px" [disabled]="commonService.getIsLockedEnterprise()">-->
                <!--                  <span matTooltip="{{'enterprise_customer_management.buttons.configure' | translate}}">-->
                <!--                    <mat-icon class="custon-icon-setting-configure">settings</mat-icon>-->
                <!--                  </span>-->
                <!--                </button>-->
                <button mat-icon-button (click)="createOrEditGroupDocument(element)"
                  [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_customer_management.buttons.edit' | translate}}">edit
                  </mat-icon>
                </button>
                <button mat-icon-button (click)="onClickDeleteButton(element)"
                  [disabled]="commonService.getIsLockedEnterprise()">
                  <!-- <mat-icon color="primary"
                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}">delete
                  </mat-icon> -->
                  <i class="fa fa-trash" style="font-size: 20px;" aria-hidden="true"
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 140px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>


            <!-- mat-header-cell add to top of table -->
            <!-- STT -->
            <ng-container matColumnDef="firstId">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>


            <!-- Group name Column -->
            <ng-container matColumnDef="firstName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Group code Column -->
            <ng-container matColumnDef="firstCode">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Group note Column -->
            <ng-container matColumnDef="firstNote">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Config Column -->
            <ng-container matColumnDef="firstValidate">
              <mat-header-cell *matHeaderCellDef [style.minWidth]='widthHeadCofig' [style.maxWidth]='widthHeadCofig'
                [style.width]='widthHeadCofig'
                class="mat-header-cell-center config-document-type-header-col group-header positon-relative">
                {{'headertable.service_type_config' | translate}}
                <mat-icon matSuffix style="cursor: pointer;"
                  matTooltip="{{'service_type.help_configure.tooltip' | translate}}" class="custom-position-for-icon"
                  (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">help_outline
                </mat-icon>
                <mat-icon class="custom-icon-configure" (click)="onOpenPickTypeConfigureDisplayed()">
                  <img src="./assets/images/version2/filter_1.svg" alt="">
                </mat-icon>
                <ng-template #tplHelpTitle>
                  <span>{{'service_type.help_configure.modal_title' | translate}}</span>
                </ng-template>
                <ng-template #tplHelpContent>
                  <p><b>{{'service_type.help_configure.modal_content1' | translate}}</b>
                    {{'service_type.help_configure.modal_content2' | translate}}
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content3' | translate}}</b>
                    {{'service_type.help_configure.modal_content4' | translate}}
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content5' | translate}}</b>
                    {{'service_type.help_configure.modal_content6' | translate}}
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content7' | translate}}</b>
                    {{'service_type.help_configure.modal_content8' | translate}}
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content9' | translate}}</b>
                    {{'service_type.help_configure.modal_content10' | translate}}
                  </p>

                  <p><b>{{'service_type.help_configure.modal_content15' | translate}}</b>
                    {{'service_type.help_configure.modal_content16' | translate}}
                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile' |
                      translate}}</span>
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content17' | translate}}</b>
                    {{'service_type.help_configure.modal_content18' | translate}}
                    <span style="color: red;">{{'service_type.help_configure.modal_content_only_mobile' |
                      translate}}</span>
                  </p>

                  <p><b>{{'service_type.help_configure.modal_content11' | translate}}</b>
                    {{'service_type.help_configure.modal_content12' | translate}}
                  </p>
                  <p><b>{{'service_type.help_configure.modal_content13' | translate}}</b>
                    {{'service_type.help_configure.modal_content14' | translate}}
                  </p>
                </ng-template>
                <ng-template #tplHelpFooter>
                  <button nz-button nzType="primary" (click)="destroyTplModal()">
                    {{'button.close' | translate}}
                  </button>
                </ng-template>
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="firstAction" class="mat-column-symbol  ">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"
                style="max-width: 140px;">
              </mat-header-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 140px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- <mat-header-row class="row-special " *matHeaderRowDef="displayedFirstColumns; sticky: true"></mat-header-row> -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
            class="table-skeleton-row"
            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>
        <!-- Pagination -->
        <div class="d-flex justify-content-between w-100">
          <div *ngIf="checkNote && !checkNote.length"></div>
          <div *ngIf="checkNote && checkNote.length" style="margin-top: 10px;" class="d-flex">
            <i style="font-size: 16px; margin-top: 1px;" class="fa fa-star text-primary"></i>
            <div style="font-size: 12px;" class="font-italic ml-1">
              {{'service_type.message_service_type' | translate}}
            </div>
          </div>
          <div style="width: 100rem;">
            <app-pagination [(paginate)]="paginate" (pageChange)="onPageChange($event.page, $event.pageSize)"
                            [isShowNoRecord]="!isTableLoading">
            </app-pagination>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
